<template>
    <label>
        <Icon id="clip" size="20"></Icon>
        <input type="file" @change="$emit('change', $event.target.files)" style="display: none">
    </label>
</template>

<script>
export default {
    name: "Attach",
}
</script>